
import { addPost, getPost, deletePost } from '@/api/post';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class extends Vue {
  mounted() {
    this.getPost();
  }

  private loading = true;

  private post = {
    title: '',
    content: '',
    writer: '',
    createDate: '',
    children: [],
  };

  private formData = {
    title: '',
    content: '',
    parentUid: '',
    boardUid: '',
  }

  private getPost() {
    this.loading = true;
    console.log(this.$route.params.uid);
    getPost(this.$route.params.uid).then((res) => {
      this.loading = false;
      this.post = res.data;
      this.formData = {
        ...this.formData,
        title: `${res.data.title} 답글`,
        parentUid: this.$route.params.uid,
        boardUid: res.data.boardUid,
        content: '',
      };
    });
  }

  /* eslint-disable */
  private handleReply() {
    if (!this.formData.content) {
      this.$message.warning('답글 내용을 입력해주세요.');
      return;
    }
    this.$confirm('정말 답글을 추가하시겠습니까?', '답글 추가', {
      confirmButtonText: '추가',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      addPost(this.formData).then(() => {
        this.$message.success('답글을 추가했습니다.');
        this.getPost();
      });
    });
  }

  private handleDeleteReply(uid: string) {
    this.$confirm('정말 답글을 삭제하시겠습니까?', '답글 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      deletePost(uid).then(() => {
        this.$message.success('답글을 삭제했습니다.');
        this.getPost();
      });
    });
  }
}
